import {
  Directive,
  HostBinding,
  Input,
  TemplateRef
} from '@angular/core';

@Directive({
  selector: '[appPickerChoice]'
})
export class PickerChoiceDirective<T> {
  itemTemplate: TemplateRef<any>;
  @Input() appPickerChoice: T;
  @HostBinding('style.cursor')
  cursor = 'pointer';

  constructor(private templateRef: TemplateRef<any>) {
    this.itemTemplate = templateRef;
  }
}
